export class GetHomePageAction {
  static readonly type = '[Home Page] Get';
  constructor(public slug?: string) {}
}
